import { render, staticRenderFns } from "./flag-applicant.component.vue?vue&type=template&id=5fa885ee&"
import script from "./flag-applicant.component.ts?vue&type=script&lang=ts&"
export * from "./flag-applicant.component.ts?vue&type=script&lang=ts&"
import style0 from "./flag-applicant.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports